<template>
  <div class="container p-1 my-4 align-items-center">
    <div class="aguarde-container text-center" v-if="loading">
      <div class="spinner-border" role="status"></div>
      <br />
      <span>Aguarde...</span>
    </div>

    <div class="card p-3 mt-5" v-if="recorrencia.tipo === 'ASSINATURA_PAGAMENTO_PJ'">
      Você não possui parcela
    </div>
    
    <div class="listarPedidos" v-if="recorrencia.pagamentos && !loading && recorrencia.tipo !== 'ASSINATURA_PAGAMENTO_PJ'">
      <div class="row d-flex justify-content-between flex-lg-row mt-2">
        <span class="col-3 px-4 py-1">
          <small><strong>Recorrência</strong><br />
            <span class="text-uppercase">{{ recorrencia.descricaoCurta }}
            </span>
          </small>
        </span>
        <span class="col-3 px-4 py-1">
          <small><strong>Periodicidade</strong><br />
            <span class="text-uppercase">
              {{ recorrencia.tipoPeridodicidade }}</span>
          </small>
        </span>
        <span class="col-3 px-4 py-1">
          <small><strong>Status</strong><br />
            <span class="text-uppercase">
              {{ formatarStatus(recorrencia.status) }}</span>
          </small>
        </span>
        <span class="col-12 mt-2 px-4 py-1">
          <small>
            <strong>Descrição</strong>
            <br />
            <span v-html="recorrencia.descricao"></span>
          </small>
        </span>
      </div>
      <ul class="p-1 list-group">
        <li @click="openDetalhesPagamento(pagamento.id)"
          class="card px-4 py-1 mb-1 shadow btn text-left list-group-item mt-2" v-for="(pagamento, i) in orderPagamento"
          :key="i">
          <div class="d-flex justify-content-between flex-lg-row mt-2">
            <span class="col-2">
              <small>Nº</small> <br />
              <strong>{{ i + 1 }}/ {{ recorrencia.quantidadeParcelas }}</strong>
            </span>
            <span class="col-2">
              <small>Situação</small> <br />
              <span v-if="pagamento.status == 'PAGAMENTO_REALIZADO'" class="badge badge-success">Paga
                <br />
                <small>{{ formatDate(pagamento.dataLimite) }}</small>
              </span>
              <span v-if="pagamento.status == 'CANCELADO'" class="badge badge-danger">Cancelada <br />
                <small>{{ formatDate(pagamento.dataLimite) }}</small>
              </span>
              <span v-if="pagamento.status == 'PAGAMENTO_BLOQUEDO_RECORRENCIA'" class="badge badge-danger">Erro
                <br />
                <small>{{ formatDate(pagamento.dataLimite) }}</small>
              </span>
              <span v-if="pagamento.status == 'ESTORNADO'" class="badge badge-warning">Estornada <br />
                <small>{{ formatDate(pagamento.dataLimite) }}</small>
              </span>
              <span v-if="pagamento.status == 'ESTORNO_SOLICITADO'" class="badge badge-warning">Estorno Solicitado
                <br />
                <small>{{ formatDate(pagamento.dataLimite) }}</small>
              </span>
              <span v-if="pagamento.status == 'REGISTRO_PAGAMENTO_PENDENTE'"
                v-bind:class="formatClassePagamento(pagamento.dataLimite)">{{
                    formatStatusPagamento(pagamento.dataLimite)
                }} <br />
                <small>{{ formatDate(pagamento.dataLimite) }}</small>
              </span>
            </span>
            <br />
            <span class="col-2"><small>Valor</small><br />R${{
                formatPrice(pagamento.valor)
            }}</span>
            <span class="align-self-center h3 mt-2" style="color: var(--cor-principal)">&#10097;</span>
          </div>
        </li>
        <div class="mt-3 mb-5 px-3 col-12 d-flex flex-column flex-lg-row justify-content-between">

          <button type="button" @click="cancelar" v-if="isCancelarAssinatura" class="btn btn-danger  px-5 mt-4 py-2">
            Cancelar Assinatura
          </button>
          <button class="btn btn_color_system px-5 mt-4 py-2" @click="$router.go(-1)">
            VOLTAR
          </button>
        </div>

        <!-- </li> -->
      </ul>
    </div>
  </div>
</template>

<script>
import { APIService } from "../../APIService";
const apiService = new APIService();

export default {
  name: "MinhasParcelas",
  props: [],
  data() {
    return {
      loading: false,
      recorrenciaId: this.$route.params.recorrenciaId,
      recorrencia: {
        pagamentos: [],
      },
      isCancelarAssinatura: false
    };
  },
  created() {
    this.obterMinhasParcelas();
  },
  methods: {
    cancelar() {
      this.loading = true;
      apiService
        .cancelarAssinatura(this.recorrencia.codigoReferencia)
        .then(() => {
          this.$swal({
            title: "Solicitação de cancelamento",
            text: "Sua solicitação foi realizada com sucesso, em breve você receberá mais informações por e-mail.",
          }).then(() => {
            this.$router.push(`/minhas-recorrencias`);
            this.loading = false;
          });
        })
        .catch(() => {
          this.loading = false;
          this.$swal({ text: "Não foi possível realizar o cancelamento" });
        });
    },
    obterMinhasParcelas() {
      this.loading = true;
      apiService
        .obterMinhasParcelas(this.recorrenciaId)
        .then((res) => {
          this.recorrencia = res;
          this.loading = false;
          this.isCancelarAssinatura = !(this.recorrencia.pagamentos.filter(o => o.status == "PAGAMENTO_REALIZADO").length === this.recorrencia.pagamentos.length);
        })
        .catch(() => {
          this.loading = false;
        });
    },
    openDetalhesPagamento(pagamentoid) {
      this.$router.push(
        `/detalhes-parcela/${this.recorrenciaId}/${pagamentoid}`
      );
    },
    formatCodigoPagamento(codigoReferencia) {
      return codigoReferencia == null
        ? ""
        : codigoReferencia.toUpperCase().substring(0, 8);
    },
    formatPrice(value) {
      if (value) {
        let val = (value / 1).toFixed(2).replace(".", ",");
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      }
    },
    formatDate(date) {
      return this.$moment(date).format("DD/MM/YYYY");
    },
    formatClassePagamento(date) {
      return this.$moment(date).isBefore(this.$moment(new Date()))
        ? "badge badge-danger"
        : "badge badge-primary";
    },
    formatStatusPagamento(date) {
      return this.$moment(date).isBefore(this.$moment(new Date()))
        ? "Atrasada"
        : "Em Aberta";
    },
    goToStep(value) {
      if (value === "assinaturas") {
        this.$router.push(`/assinaturas`);
      }
    },
    formatarStatus(status) {
      if (status === 'CANCELADO_RECEBEDOR' || status === 'CANCELADO_PAGADOR') {
        return 'Cancelado';
      } else if (status === 'INICIADO') {
        return 'ATIVO';
      } else if (status === 'PARADO' || status === 'SUSPENSO') {
        return 'Suspenso';
      } else {
        return status;
      }
    },
    ordernarPagamentos() {
      return this.recorrencia.pagamentos.sort(function (a, b) {
        return a.id - b.id;
      });
    },
  },
  computed: {
    orderPagamento() {
      return this.ordernarPagamentos();
    }
  },
};
</script>

<style  scoped lang="scss">
.color-system-principal {
  color: var(--cor-principal) !important;
}

.color-system-background {
  background-color: var(--cor-principal) !important;
  color: white;
}
</style>